import React from 'react';
import { Typo, Icon } from '@ers/ui';
import { BigIconPanel } from '.';


const NoFiles = () => (
    <BigIconPanel>
        <Icon name="noFiles" big />
        <Typo.Body>Nie wysłałeś żadnych plików w tej rekrutacji</Typo.Body>
    </BigIconPanel>
);

export default NoFiles;
